import { gql } from '@apollo/client'

export const SIMPLE_INVENTORY_FRAGMENT = gql`
  fragment SimpleInventory on SimpleInventoryItem {
    parentId
    quantity
    upc
  }
`
